import { useQuery } from '@tanstack/react-query';
import { useApi } from 'common/hooks/api';
import logger from 'itrvl-logger';
const log = logger(__filename);
log.trace(__filename);

export function useWhoAmI(token) {
  const Api = useApi();
  const query = useQuery({
    queryKey: ['whoAmI', token],
    queryFn: async () => {
      if (!token) return {};
      const response = await Api.userInfo(token);
      return response?.data || {};
    },
    retry: false,
    staleTime: 6000,
    cacheTime: 6000,
  });
  return query;
}
